/* PDP - Description Tab JS */

document.addEventListener('DOMContentLoaded', function () {
  /* Desktop Tabs */
  const tabs = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.product-tab-content');

  function activateTab(tab) {
    const target = tab.dataset.target;

    // reset all tabs
    tabs.forEach((t) => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    // hide all panels
    tabContents.forEach((c) => {
      c.classList.remove('active');
    });

    // activate clicked tab
    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    tab.focus();

    const activeTab = document.getElementById(target);
    if (activeTab) {
      activeTab.classList.add('active');
    }
  }

  // CLICK SUPPORT
  tabs.forEach((btn) => {
    btn.addEventListener('click', function () {
      activateTab(this);
    });
  });

  // KEYBOARD SUPPORT
  tabs.forEach((tab, index) => {
    tab.addEventListener('keydown', function (e) {
      let newIndex = index;

      // RIGHT ARROW
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        newIndex = (index + 1) % tabs.length;
        tabs[newIndex].focus();
      }

      // LEFT ARROW
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        newIndex = (index - 1 + tabs.length) % tabs.length;
        tabs[newIndex].focus();
      }

      // HOME
      if (e.key === 'Home') {
        e.preventDefault();
        tabs[0].focus();
      }

      // END
      if (e.key === 'End') {
        e.preventDefault();
        tabs[tabs.length - 1].focus();
      }

      // ENTER / SPACE = activate
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(tab);
      }
    });
  });

  // INITIAL TABINDEX SETUP
  tabs.forEach((tab, i) => {
    tab.setAttribute('tabindex', i === 0 ? '0' : '-1');
  });

  /* Mobile Accordion */

  const accordionBtns = document.querySelectorAll('.mobile-accordion-title');

  accordionBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const parent = this.closest('.product-tab-content');

      // close others
      tabContents.forEach((tab) => {
        if (tab !== parent) {
          tab.classList.remove('active');
          const accBtn = tab.querySelector('.mobile-accordion-title');
          if (accBtn) accBtn.setAttribute('aria-expanded', 'false');
        }
      });

      // toggle current
      const isOpen = parent.classList.toggle('active');
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
});
